import React from "react";

import { PageLayout } from "../../layouts/PageLayout";
import { NoPermission } from "../../components/v3/NoPermission";

export const NoPermissionPage = () => {
  return (
    <PageLayout>
      <NoPermission />
    </PageLayout>
  );
};
